<template>
  <div class="page-detail">
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in pics" :key="index">
        <img v-lazy="image" />
      </van-swipe-item>
    </van-swipe>
    <div class="detail-txt">
      <h2>藏品数据</h2>
      <div class="detail-txt_table">
        <div class="detail-txt_tableName">
          <div>藏品名称</div>
          <div>藏品总登记号</div>
          <div>原名</div>
          <div>具体年代</div>
          <div>藏品类别</div>
          <div>质地</div>
          <div>实际数量</div>
          <div>外型尺寸（cm)</div>
          <div>具体尺寸</div>
          <div>具体质量</div>
          <div>藏品级别</div>
          <div>藏品来源</div>
        </div>
        <div>
          <div>{{ detailData.mingchen || "" }}</div>
          <div>{{ detailData.bianhao || "" }}</div>
          <div>{{ detailData.mingchen || "" }}</div>
          <div>{{ detailData.niandai_juti || "" }}</div>
          <div>{{ detailData.leibie || "" }}</div>
          <div>{{ detailData.zhidi || "" }}</div>
          <div>{{ detailData.shuliang || "" }}</div>
          <div>{{ detailData.chicun || "" }}</div>
          <div>{{ detailData.chicun || "" }}</div>
          <div>{{ detailData.zhiliang_juti + "kg" || "" }}</div>
          <div>{{ detailData.jibie || "" }}</div>
          <div>{{ detailData.laiyuan || "" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
export default {
  data() {
    return {
      detailData: {},
    };
  },
  computed: {
    pics() {
      return this.detailData.pics;
    },
  },
  created() {
    this.detailData = this.$route.query.item;
  },
  mounted() {},
  methods: {},
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
};
</script>

<style lang="less" scoped>
.page-detail {
  .detail-txt {
    h2 {
      font-size: 24px;
    }
    .detail-txt_table {
      display: grid;
      grid-template-columns: 0.7fr 1fr;
      padding: 10px;
      div {
        div {
          border: 1px solid #000;
          margin-bottom: -1px;
          color: #212121;
          font-size: 16px;
          padding: 9px 15px;
          min-height: 20px;
          line-height: 20px;
          background-color: #fff;
        }
      }
      .detail-txt_tableName {
        margin-right: -1px;
      }
    }
  }
}
</style>